export default [
    {
        name: 'Streams',
        sub_name: '1\'384',
        price:573.40,
        price2: 95.20
    },
    {
        name: 'Downloads',
        sub_name: '201',
        price:306.80,
        price2: 63.40
    },
    {
        name: 'Physische Verkäufe',
        sub_name: '29',
        price:293.20,
        price2: 29.70
    },
    {
        name: 'Weitere Einnahmen',
        sub_name: 'Mitwirkender',
        price:107.90,
        price2: 12.30
    },
]



// WEBPACK FOOTER //
// ./src/data/meine_trends.js